import { PagePagination } from '@playbooks/molecules/paginations/page-pagination';
import { PageSizePagination } from '@playbooks/molecules/paginations/page-size-pagination';
import { toNumber } from '@playbooks/utils';

type TablePaginationProps = {
	meta: any;
	params: any;
	setParams: (params: any) => void;
	pageSizes?: number[];
	totalLabel?: string;
};

const TablePagination = ({ meta, params, setParams, pageSizes, totalLabel = 'records' }: TablePaginationProps) => (
	<div className='flex-between w-full min-w-0 gap-3'>
		<span className='flex-start min-w-0 gap-3 overflow-x-auto custom-scrollbar'>
			<PagePagination compact meta={meta} params={params} setParams={setParams} />
			<small className='whitespace-nowrap type-meta'>
				{toNumber(meta.totalRecords)} {totalLabel}
			</small>
		</span>
		<PageSizePagination meta={meta} params={params} setParams={setParams} pageSizes={pageSizes} />
	</div>
);
export { TablePagination };
export type { TablePaginationProps };
